'use client';

import { useCallback, useRef, useState } from 'react';

import { VideoPlayerProps } from './types';

import IconPlay from '@/assets/icons/iconPlay.svg';
import { classNames } from '@/shared/lib/classNames/classNames';

export const VideoPlayer = ({
  videoUrl,
  previewUrl,
  alt,
  className,
}: VideoPlayerProps) => {
  const playerRef = useRef<HTMLVideoElement>(null);
  const [isPreviewMode, setIsPreviewMode] = useState(true);
  const [isPause, setIsPause] = useState(false);

  const onPlayClick = useCallback(() => {
    if (isPreviewMode) {
      setIsPreviewMode(false);
    }

    setIsPause(false);
    if (playerRef.current) {
      playerRef.current.play();
    }
  }, [isPreviewMode]);

  return (
    <div className={classNames('relative w-full rounded-xl', {}, [className])}>
      <video
        ref={playerRef}
        controls={!isPreviewMode}
        poster={previewUrl}
        className="h-full w-full rounded-xl"
        onPause={() => setIsPause(true)}
        onPlay={() => setIsPause(false)}
        onEnded={() => setIsPreviewMode(true)}
      >
        <source src={videoUrl} />
      </video>
      {(isPreviewMode || isPause) && (
        <IconPlay
          onClick={onPlayClick}
          className="absolute left-[50%] top-[50%] z-10 h-[53px] w-[53px] -translate-x-1/2 -translate-y-1/2 cursor-pointer opacity-[0.5] md:h-[108px] md:w-[108px]"
        />
      )}
    </div>
  );
};
